<template>
	<div class="content-i">
		<div class="content-box">
			<div class="row mt-sm-2">
				<div class="col-sm-12 col-md-6 col-lg-12">
					<div class="element-wrapper">
						<h6 class="element-header">{{ t('manageRegistrationRequestText', 'manageRegistrationRequestText') }}</h6>
						<div class="element-box">
							<div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <span class="os-icon os-icon-search2"></span>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('headerManageRegistrationRequestSearch','headerManageRegistrationRequestSearch') }}</h5>
                        <div class="element-inner-desc">{{ t('manageRegistrationRequestFormDesc','manageRegistrationRequestFormDesc') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4">
                    <i id="reportsToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                  </div>
                </div>
              </div>
							<b-collapse id="search" v-model="visibleSearchBox">
                <form v-on:submit.prevent="requestRegistrations">
                  <div class="col-lg-12 row">
                    <div class="col-lg-2">
                      <!-- REQUESTER NAME -->
                      <div class="col-lg-12">
                        <div class="form-group">                          
                          <label for="requester-name" class="d-block text-center">{{t('manageRegistrationRequestsName','manageRegistrationRequestsName') }}</label>
                          <b-form-select id="requester-name" v-model="registrationRequest.name" :select-size="5" class="form-control custom-select text-capitalize">
                            <option value="All">{{t('allValue','allValue') }}</option>
                            <option v-for="name in dropdownValues.names" :value="name.name" :key="name.name">{{ name.name }}</option>
                          </b-form-select>
                        </div>
                      </div>                    
                    </div>                                          
                    <div class="col-lg-2">
                      <!-- REQUEST DATE FROM -->
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="event-date-from" class="d-block text-center">{{ t('ManageRegistrationRequestsDateFrom','ManageRegistrationRequestsDateFrom') }}</label>
                          <datePicker id="event-date-from" v-model="registrationRequest.date_from" class="form-control text-center" :config="datePickerAfterConfig" :placeholder="t('deliverReportSearchLabelEventDateFrom','deliverReportSearchLabelEventDateFrom')"></datePicker>
                        </div>
                      </div>
                      <!-- REQUEST DATE TO -->
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="event-date-to" class="d-block text-center">{{ t('ManageRegistrationRequestsDateTo','ManageRegistrationRequestsDateTo') }}</label>
                          <datePicker id="event-date-to" v-model="registrationRequest.date_to" class="form-control text-center" :config="datePickerBeforeConfig" :placeholder="t('deliveryReportSearchLabelEventDateTo','deliveryReportSearchLabelEventDateTo')"></datePicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <!-- REQUESTER COUNTRY -->
                      <div class="col-lg-12">
                        <div class="form-group">                          
                          <label for="requester-country" class="d-block text-center">{{t('manageRegistrationRequestsCountry','manageRegistrationRequestsCountry') }}</label>
                          <b-form-select id="requester-country" v-model="registrationRequest.country" :select-size="1" class="form-control custom-select text-capitalize">
                            <option :value='undefined' selected disabled>{{t('selectValue','selectValue') }}</option>
                            <option value="All">{{t('allValue','allValue') }}</option>
                            <option v-for="country in dropdownValues.countries" :value="country.country" :key="country.country">{{ country.country }}</option>
                          </b-form-select>
                        </div>
                      </div>
                      <!-- REQUESTER STATUS -->
                      <div class="col-lg-12">
                        <div class="form-group">                          
                          <label for="requester-status" class="d-block text-center">{{t('manageRegistrationRequestsStatus','manageRegistrationRequestsStatus') }}</label>
                          <b-form-select id="requester-status" v-model="registrationRequest.status" :select-size="1" class="form-control custom-select text-capitalize">
                            <option :value='undefined' selected disabled>{{t('selectValue','selectValue') }}</option>
                            <option value="All">{{t('allValue','allValue') }}</option>
                            <option v-for="status in dropdownValues.status" :value="status.status" :key="status.status">{{ status.status }}</option>
                          </b-form-select>
                        </div>
                      </div>  
                    </div>                                                               
                  </div>
                  <div class="col-lg-12 row">
                    <div class="col-2">
                      <b-input-group class="col-lg-12">
                        <b-input-group-prepend>
                            <label class="input-group-text">{{ t('recordsPerPageFilter', 'recordsPerPageFilter') }}</label>
                        </b-input-group-prepend>
                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                      </b-input-group>
                    </div>
                    <div class="col-10" style="text-align: right; padding-right: 0px;">
                      <button v-if="!buttonsBusy" class="btn btn-primary" type="submit" >{{ t('searchRegistrationRequestBtn','searchRegistrationRequestBtn') }}</button>
                      <b-button v-else variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        {{ t('searchRegistrationRequestBtn','searchRegistrationRequestBtn') }}
                      </b-button>
                    </div>                    
                  </div>
                </form>
							</b-collapse>
						</div>
            <transition name="fade">
              <ResponseInfo v-if="getResponseInfo.responseName == 'manageRegistrationRequest'" class="mt-2"/>				
            </transition>	         
            <div class="element-box">
              <div class="row col-lg-12">
                <button class="btn btn-primary" v-if="!buttonsBusy" :disabled="selectedRequests.length <= 0" @click="updateReuqest('accepted')">{{ t('acceptSelectedRequestBtn','acceptSelectedRequestBtn') }}</button>
                <b-button v-else variant="primary" disabled>
                  <b-spinner small type="grow"></b-spinner>
                  {{ t('acceptSelectedRequestBtn','acceptSelectedRequestBtn') }}
                </b-button>
                <button class="btn btn-primary" v-if="!buttonsBusy" :disabled="selectedRequests.length <= 0" @click="updateReuqest('denied')">{{ t('rejectSelectedRequestBtn','rejectSelectedRequestBtn') }}</button>
                <b-button v-else variant="primary" disabled>
                  <b-spinner small type="grow"></b-spinner>
                  {{ t('rejectSelectedRequestBtn','rejectSelectedRequestBtn') }}
                </b-button>
                <div class="col-lg-2 col-md-3 col-sm-12 mb-2 mb-md-0">
                  <b-input-group>
                      <b-form-input v-model="searchInput" v-on:input="generalSearch()" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button @click="clearSearchInput" :disabled="!searchInput">{{ t('clearButtonText','clearButtonText') }}</b-button>
                      </b-input-group-append>
                  </b-input-group>
                </div>
              </div>
              <div class="controls-below-table pt-4 row">
                <div class="col-sm-12 col-md-6 table-records-info" v-if="getRegistrationRequestList.data">
                  <p>{{ totalRows }} {{ t('registrationReqListEntriesFound','registrationReqListEntriesFound') }}</p>
                </div>
                <div class="col-sm-12 col-md-4" v-if="getRegistrationRequestList.data">
                  <b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-md-2">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>    
              <div class="table-responsive">
                <b-table id="logs-table" striped hover bordered class="mt-3 " :busy.sync="isBusy" v-if="getRegistrationRequestList.data" :items="getRegistrationRequestList.data" :fields="fields" :total-rows="totalRows" :per-page="0" :currentPage="currentPage" :show-empty="rowEmpty">
                  <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="data.item">
                    <vcl-table :rows="parseInt(perPage)" :columns="5"></vcl-table>
                  </template>
                  <template slot="empty" slot-scope="items" >
                    <span>{{ t('registrationRequestsNoEntries','registrationRequestsNoEntries') }}</span>
                  </template>
                  <template v-slot:head(selectRequest)="data">
                    <template v-if="!selectAll">
                      <fontAwesomeIcon @click="checkAllRegs()" :icon="['far', 'square']"class="showhand"size="lg"/><span class="pl-1">{{ t('selectAll','selectAll') }}</span>
                    </template>
                    <template v-if="selectAll">
                      <fontAwesomeIcon @click="uncheckAllRegs()" :icon="['far', 'check-square']"class="showhand"size="lg"/><span class="pl-1">{{ t('unselectAll','unselectAll') }}</span>
                    </template>
                  </template>     
                  <template v-slot:head(requestDate)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(customerRef)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(customerName)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(requesterName)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(country)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(action)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>
                  <template v-slot:head(status)="data">
                    <span >{{ t(data.label, data.label) }}</span>
                  </template>             
                  <template v-slot:cell(selectRequest)="data">
                    <div class="checkbox-align-center">
                      <b-form-checkbox :value="data.item.regis_id" v-model="selectedRequests"></b-form-checkbox>
                    </div>
                  </template>                  
                  <template v-slot:cell(requestDate)="data">
                    <span>{{ data.item.request_date }}</span>
                  </template>
                  <template v-slot:cell(customerRef)="data">
                    <span>{{ data.item.customer_reference }}</span>
                  </template>
                  <template v-slot:cell(customerName)="data">
                    <span>{{ data.item.customer_name }}</span>
                  </template>
                  <template v-slot:cell(requesterName)="data">
                    <span>{{ data.item.requester_name }}</span>
                  </template>                  
                  <template v-slot:cell(country)="data">
                    <span>{{ data.item.english }}</span>
                  </template>
                  <template v-slot:cell(action)="data">
                    <button v-if="!buttonsBusy" class="btn btn-primary" @click="openViewDetailsModal(t('infoRegistrationRequesterDetailsModalTitle', 'infoRegistrationRequesterDetailsModalTitle'), data.item.status, data.item.request_date, data.item.customer_reference, data.item.customer_name, data.item.requester_email, data.item.requester_name, $event.target)">{{ t('viewDetailsBtn','viewDetailsBtn') }}</button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small type="grow"></b-spinner>
                      {{ t('rejectSelectedRequestBtn','rejectSelectedRequestBtn') }}
                    </b-button>
                  </template>
                  <template v-slot:cell(status)="data">
                    <span>{{ data.item.status }}</span>
                  </template>                                    
                </b-table>
              </div>
              <div class="controls-below-table pt-4 row">
                <div class="col-sm-12 col-md-6 table-records-info" v-if="getRegistrationRequestList.data">
                  <p>{{ totalRows }} {{ t('registrationReqListEntriesFound','registrationReqListEntriesFound') }}</p>
                </div>
                <div class="col-sm-12 col-md-4" v-if="getRegistrationRequestList.data">
                  <b-pagination class="float-right mb-0" v-model="currentPage" v-if="totalRows > 0" :total-rows="totalRows" :per-page="perPage" aria-controls="logs-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-md-2">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>              
            </div>
            <!-- INFO MODAL -->
            <b-modal class="modal-lg" :id="infoModal.id" :title="infoModal.title" :header-bg-variant="'secondary'" hide-backdrop @hide="resetViewDetailsModal()">
              <template slot="modal-header" slot-scope="{ close }">
                <h5 class="modal-title text-light">{{ infoModal.title }}</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">x</span></button>
              </template>
              <template slot="default">
                <div class="row modal-body-log">
                  <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                    <b-input-group>
                      <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                        <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('registrationStatusLabel', 'registrationStatusLabel') }}</span></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="infoModal.status" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group class="pt-2">
                      <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                        <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('registrationRequestDateLabel', 'registrationRequestDateLabel') }}</span></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="infoModal.requestedDate" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group class="pt-2">
                      <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                        <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('registrationRequesterCustomerRefLabel', 'registrationRequesterCustomerRefLabel') }}</span></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="infoModal.customerRef" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group class="pt-2">
                      <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                        <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('registrationRequesterCustomerNameLabel', 'registrationRequesterCustomerNameLabel') }}</span></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="infoModal.customerName" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group class="pt-2">
                      <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                        <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('registrationRequesterEmailLabel', 'registrationRequesterEmailLabel') }}</span></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="infoModal.requesterEmail" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group class="pt-2">
                      <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                        <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('registrationRequesterNameLabel', 'registrationRequesterNameLabel') }}</span></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input v-model="infoModal.requesterName" disabled></b-form-input>
                    </b-input-group>                                        																
                  </b-form-group>
                </div>
              </template>			
              <template slot="modal-footer" slot-scope="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()">Cancel</b-button>
              </template>
            </b-modal>
            <div v-if="infoModal.title" class="modal-backdrop show"></div>         
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { VclTable } from 'vue-content-loading'
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
  name: 'DeliveryReports',	
  components: {
    ResponseInfo,
    datePicker,
    VclTable
	},
	data() {
		return {
      visibleSearchBox: true,
      pageOptions: [10, 20, 50, 100],			
			perPage: 10,
      currentPage: 1,
      isBusy: false,
      buttonsBusy: false,
      totalRows: 0,
      rowEmpty: false,
      selectAll: 0,
      selectedRequests: [],
      requestId: null,
      searchInput: '', //NS-9598 SP
      registrationRequest: {
        page: this.$route.query.page,
        per_page: this.$route.query.per_page,
        date_from: this.$route.query.date_from,
        date_to: this.$route.query.date_to,
        name: this.$route.query.name,
        search: this.$route.query.search,
        country: this.$route.query.country,
        status: this.$route.query.status,
      },
      dropdownValues: {
        names: [],
        status: [],
        countries: []
      },
      fields: [
          {key: 'selectRequest', label: 'selectRequestLabel', thClass: 'showhand brand-color'},
          {key: 'requestDate', label: 'requestDateLabel', thClass: 'showhand brand-color'},
          {key: 'customerRef', label: 'customerRefLabel', thClass: 'showhand brand-color'},
          {key: 'customerName', label: 'customerNameLabel', thClass: 'showhand brand-color'},
          {key: 'requesterName', label: 'requestNameLabel', thClass: 'showhand brand-color'},
          {key: 'country', label: 'countryLabel', thClass: 'showhand brand-color'},
          {key: 'action', label: 'actionLabel', thClass: 'showhand brand-color'},
          {key: 'status', label: 'statusLabel', thClass: 'showhand brand-color'}
      ],      
      datePickerAfterConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        showClear: true
      },
      datePickerBeforeConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment('1979-01-01').format(this.datePickerFormat),
        showClear: true
      },
      infoModal: {
        id: 'info-modal-registrationDetails',
        title: '',
        status: '',
        requestedDate: '',
        customerRef: '',
        customerName: '',
        requesterEmail: '',
        requesterName: ''
      }   
		}
  },
  created() {
    //NS-9598 SP
    if(this.$route.query.id) {
      this.requestId = this.$route.query.id
    }
    this.requestRegistrations()
    this.datePickerBeforeConfig.format = this.datePickerFormat
    this.datePickerAfterConfig.format = this.datePickerFormat
    let todaysDate = moment(new Date())
    this.datePickerAfterConfig.maxDate = todaysDate
    this.datePickerBeforeConfig.maxDate = todaysDate
    maxDate: {
      this.maxDate = moment(new Date()).format(this.datePickerFormat)
    }
  },  
	methods: {
    requestRegistrations() {
      this.isBusy = true
      this.searchInput = '' //NS-9598 SP
      this.$store.dispatch('manageRegistrationRequest/getDropdownValues').then(data => {
        this.dropdownValues.names = data.names
        this.dropdownValues.status = data.status
        this.dropdownValues.countries = data.countries
      })

      Object.keys(this.registrationRequest).forEach((key) => (this.registrationRequest[key] == '') && (this.registrationRequest[key] = undefined) && (this.registrationRequest[key] != null))
      this.$router.push({ query: { ...this.$route.query, ...this.registrationRequest, page: this.currentPage, per_page: this.perPage } })
      
      this.$store.dispatch('manageRegistrationRequest/getRegistrationRequests', {
        page: this.$route.query.page,
        per_page: this.$route.query.per_page,
        date_from: this.$route.query.date_from,
        date_to: this.$route.query.date_to,
        name: this.$route.query.name,
        search: this.$route.query.search,
        country: this.$route.query.country,
        status: this.$route.query.status,
        requestId: this.requestId //NS-9598 SP
      }).then(() => {
        this.isBusy = false //NS-9598 SP
        this.buttonsBusy = false //NS-9598 SP
        this.totalRows = this.getRegistrationRequestList.total
        this.requestId = null //NS-9598 SP
        if((this.getRegistrationRequestList.data === undefined)||(this.getRegistrationRequestList.data.length == 0)){
          this.rowEmpty = true
        } else {
          this.rowEmpty = false
        }
      })
    },
    openViewDetailsModal(title, status, requestedDate, customerRef, customerName, requesterEmail, requesterName, button) {
      this.infoModal.title = title
      this.infoModal.status = status
      this.infoModal.requestedDate = requestedDate
      this.infoModal.customerRef = customerRef
      this.infoModal.customerName = customerName
      this.infoModal.requesterEmail = requesterEmail
      this.infoModal.requesterName = requesterName
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
		resetViewDetailsModal() {
      this.infoModal.title = ''
			this.infoModal.status = '' 
			this.infoModal.requestedDate = '' 
			this.infoModal.customerRef = '' 
			this.infoModal.customerName = '' 
      this.infoModal.requesterEmail = ''
      this.infoModal.requesterName = ''
		},    
    updateReuqest(status) {
      this.buttonsBusy = true //NS-9598 SP
      if(this.selectedRequests.length > 0) {
        this.$store.dispatch('manageRegistrationRequest/updateRegistrationStatus', {
          registrationIds: this.selectedRequests,
          status: status,
          currentUser: this.getUserDetails.id
        }).then(() => {
          this.buttonsBusy = false //NS-9598 SP
          this.selectAll = 0
          this.selectedRequests = []
          if(!this.searchInput) { //NS-9598 SP 
            this.requestRegistrations()
          } else {
            this.generalSearch()
          }
        })
      }
    },
    generalSearch() { //NS-9598 SP General search function added
      this.isBusy = true
      this.buttonsBusy = true
      this.$store.dispatch('manageRegistrationRequest/getRegistrationRequestsFromSearchInput', {
        searchInput: this.searchInput,
        page: this.currentPage,
        per_page: this.perPage
      }).then(() => {
        this.isBusy = false
        this.buttonsBusy = false
        this.totalRows = this.getRegistrationRequestList.total
        if((this.getRegistrationRequestList.data === undefined)||(this.getRegistrationRequestList.data.length == 0)){
          this.rowEmpty = true
        } else {
          this.rowEmpty = false
        }
      })
    },
    clearSearchInput() { //NS-9598 SP claer the search input 
      this.searchInput = ''
      this.requestRegistrations()
    },
    checkAllRegs() {
      let registrationRequests = this.getRegistrationRequestList.data
      let allRegIds = []
      Object.keys(registrationRequests).forEach((key) => (allRegIds.push(registrationRequests[key].regis_id)))
      this.selectedRequests = allRegIds
      this.selectAll = 1
    },
    uncheckAllRegs() {
      this.selectedRequests = []
      this.selectAll = 0
    },
  },
  computed: {
    ...mapGetters(['getResponseInfo', 'getUserDetails', 'getUserLevel', 'allTemplateDetails']),
    ...mapGetters('manageRegistrationRequest', ['getRegistrationRequestList']),
    date_from() {
      return this.registrationRequest.date_from
    },
    datePickerFormat() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
        return dateformat
      } else {
        return "DD-MM-YYYY"
      }
    }
  },
  watch: {
    date_from(date) {
      if(date) {
        let dateFrom = moment(date, this.datePickerFormat)
        this.datePickerBeforeConfig.minDate = dateFrom
      } else {
        this.datePickerBeforeConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    },
    'currentPage'() {
      this.requestRegistrations()
    },
    'perPage'() {
      this.requestRegistrations()
    }    
  }
}
</script>

<style scoped>
  .text-netsend-blue {
    color: #047bf8;
  }
  .showhand {
    cursor: pointer;
  }
  #reportsToggle {
    font-size: 1.2rem;
    font-weight: bold;
    display:inline-block;
    -moz-transition: all .5s linear;
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
  }
  #reportsToggle.collapsed {
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    transform:rotate(180deg);
  }
  .checkbox-align-center {
		display: flex;
		justify-content: center;
	}
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  table >>> tbody, table >>> thead {
    text-align: center;
  }  
</style>